import { Buttons, Colors, Sizes } from 'styles';

const styles = {
  searchTextField: {
    backgroundColor: Colors.toolbarButtonNormal,
    borderRadius: 16,
    marginRight: 10,
  },
  searchTextFieldInput: {
    paddingLeft: 37,
    paddingRight: 20,
    paddingTop: 0,
    paddingBottom: 0,
    width: 200,
    height: 32,
    color: Colors.white,
    fontSize: Sizes.textSubhead,
  },
  columnList: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: Colors.toolbarDropDownBackground,
    padding: 0,
    marginTop: 50,
  },
  cancelButton: {
    ...Buttons.button,
    borderRadius: 16,
    width: 82,
    height: 32,
  },
  tabsWrapper: {
    position: 'relative',
    marginRight: '1.5rem',
  },
  tabsIndicator: {
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    zIndex: '-1',
    '& > div': {
      width: '100%',
      height: '100%',
      backgroundColor: Colors.blue2,
      transition: 'all 0s cubic-bezier(0.22, 1, 0.36, 1)',
    },
  },
  tabRoot: {
    minWidth: '11rem',
    maxWidth: '11rem',
    minHeight: Sizes.toolbarHeight,
    textTransform: 'none',
    fontSize: '1.5rem',
    whiteSpace: 'nowrap',
    color: '#fff',
    opacity: 1,
    '& > span > span': {
      padding: 0,
    },
  },
  badgeRoot: {
    width: 65,
    justifyContent: 'center',
  },
  badge: {
    height: 18,
    marginRight: -4,
    marginTop: -4,
    backgroundColor: Colors.red2,
  },
} as const;

export default styles;
